import { render, staticRenderFns } from "./button-view.vue?vue&type=template&id=59daa190&scoped=true"
import script from "./button-view.vue?vue&type=script&lang=js"
export * from "./button-view.vue?vue&type=script&lang=js"
import style0 from "./button-view.vue?vue&type=style&index=0&id=59daa190&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59daa190",
  null
  
)

export default component.exports